import classNames from "classnames"
import { cloneElement } from "react"

import type { TagProps } from "@bounce/design-system"

const getBgColor = (bgColor: string) => {
  return {
    neutral: "bg-neutral-200",
    purple: "bg-lilac-200",
    green: "bg-green-200",
    yellow: "bg-yellow-200",
  }[bgColor]
}

const getTextColor = (bgColor: string) => {
  return {
    neutral: "text-neutral-900",
    purple: "text-lilac-700",
    green: "text-green-700",
    yellow: "text-stone-900",
  }[bgColor]
}

export const StoreCardTag = ({ bgColor, className, icon, text }: TagProps) => {
  return (
    <div
      className={classNames(
        getBgColor(bgColor),
        "flex w-fit flex-row content-center items-center justify-center self-start whitespace-nowrap rounded-3xl px-2 py-1 text-center text-sm font-semibold",
        className,
      )}>
      <span>
        {icon &&
          cloneElement(icon, {
            ...icon.props,
            height: 14,
            width: 14,
            className: classNames(icon.props.className, "mr-1"),
          })}
      </span>
      <span className={classNames(getTextColor(bgColor), "leading-none")}>{text}</span>
    </div>
  )
}
